var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPuntosPasivo24X24(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0004 7.2C11.1167 7.2 10.4004 6.48366 10.4004 5.6C10.4004 4.71634 11.1167 4 12.0004 4C12.884 4 13.6004 4.71634 13.6004 5.6C13.6004 6.48366 12.884 7.2 12.0004 7.2Z",
    fill: "#6CD39B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0004 13.6C11.1167 13.6 10.4004 12.8837 10.4004 12C10.4004 11.1163 11.1167 10.4 12.0004 10.4C12.884 10.4 13.6004 11.1163 13.6004 12C13.6004 12.8837 12.884 13.6 12.0004 13.6Z",
    fill: "#6CD39B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0004 20C11.1167 20 10.4004 19.2837 10.4004 18.4C10.4004 17.5163 11.1167 16.8 12.0004 16.8C12.884 16.8 13.6004 17.5163 13.6004 18.4C13.6004 19.2837 12.884 20 12.0004 20Z",
    fill: "#6CD39B"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPuntosPasivo24X24);
export default __webpack_public_path__ + "static/media/PUNTOS_PASIVO_24x24.1b7e54963d6dc5f0a56ba96c395231b4.svg";
export { ForwardRef as ReactComponent };